export default __webpack_public_path__ + "static/media/ic_error_lock.3c3f119c.svg";